module.exports = __webpack_public_path__ + "static/media/icon-fight.64338ca0.png";